<template lang="pug">
.v-offers-product.offers-product
	.container(v-if="data")
		.offers-product__head(v-if="data.title")
			component.offers-product__title(
				:is="data.titleLevel ? data.titleLevel : 'h3'"
				:class="data.titleStyleLevel"
				) {{data.title}}
		.offers-product__filter
			template(v-for="(field, index) in data.filters" :key="index" )
				v-field(:field="field"
					v-model="field.value"
					@update:model-value="updateFilter(field)")
		transition-group.offers-product__grid(tag="div" name="list-fade")
			.offers-product__item(v-for="(item, index) in filteredItems" :key="item" )
				v-product(:product="item")

</template>

<script>
	import sourceMixin from '../components/mixins/v-mixin-source.vue';
	export default {
		mixins: [
			sourceMixin
		],
		data() {
			return {
				data: null,
				filterState: {},
			}
		},
		computed: {
			filteredItems() {
				let items = this.data.items || [];
				let filterStateKeys = Object.keys(this.filterState);
				if (items.length && filterStateKeys.length > 0) {
					filterStateKeys.forEach(key => {
						if (!this.filterState[key] || !this.filterState[key].length || !this.filterState[key][0]) {
							return false;
						}
						items = items.filter(item => {
							let filterResult = false;
							if (typeof item.filter == 'undefined' || !item.filter || !item.filter.hasOwnProperty(key) ||  typeof item.filter[key]  == 'undefined') {
								return filterResult;
							}
							if (Array.isArray(item.filter[key])) {
								this.filterState[key].forEach(filterStateItem => {
									if (!filterResult) {
										filterResult = (item.filter[key].findIndex(itemKey => itemKey === filterStateItem)) > -1;
									}
								});
							} else if (typeof item.filter[key] === 'boolean') {
								if (this.filterState[key][0] === item.filter[key]) {
									return true;
								}
							}
							return filterResult;
						});
					});
				}

				return items;
			},
		},
		methods: {
			dataSet(data) {
				this.data = data;
			},
			updateFilter(field) {
				if (Array.isArray(field.value)) {
					this.filterState[field.name] = field.value.length && field.value[0] ? field.value : [];
				} else {
					this.filterState[field.name] = field.value ? [field.value] : [];
				}
				if(field.type === 'toggler') {
					this.filterState[field.name] = field.value ? [field.value] : [field.options[0].value];
				}
			},
		}
	}
</script>